var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"border-bottom":"2px solid #0288d1"}},[_c('span',{ref:"value",staticClass:"inputvalue",attrs:{"contenteditable":true},on:{"focus":_vm.focus,"blur":_vm.blur,"input":_vm.input}}),_c('span',{staticClass:"placeholder",attrs:{"contenteditable":true},on:{"focus":_vm.focus}},[_vm._v(_vm._s(_vm.placeholder))])])
}
var staticRenderFns = []

export { render, staticRenderFns }